import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-terms-and-conditions-content',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './terms-and-conditions-content.component.html',
  styleUrl: './terms-and-conditions-content.component.scss'
})
export class TermsAndConditionsContentComponent {

}
